import { combineEpics } from "redux-observable";
import { epicNotEnoughResourceBuyWithGold } from "./epicNotEnoughResourceBuyWithGold";
import { epicNotEnoughResourceBuyWithGoldConfirmed } from "./epicNotEnoughResourceBuyWithGoldConfirmed";
import { epicNotEnoughResourceCancel } from "./epicNotEnoughResourceCancel";
export var epicNotEnoughResource = combineEpics(epicNotEnoughResourceBuyWithGold, epicNotEnoughResourceBuyWithGoldConfirmed, epicNotEnoughResourceCancel);



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/epics/epicNotEnoughResource.ts
// module id = 2021
// module chunks = 3